import * as constants from "../constants";
export function validateEmail(elementValue) {
	var emailPattern =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailPattern.test(elementValue);
}
export function validateMobileNumber(mobvalue) {
	var mobilePattern = /^(0|[+971]{4})?[0-9]{9}$/;
	return mobilePattern.test(mobvalue);
}

export function alphaAndNumbers(aplhaNumaric) {
	var regex = /^[A-Za-z0-9]+$/;
	return regex.test(aplhaNumaric.replace(/ /g, ""));
}

export function alphabitsLetters(alphabits) {
	var letters = /^[A-Za-z]+$/;
	return letters.test(alphabits.replace(/ /g, ""));
}

export function isSplChar(alphabits) {
	var SplCharacterPattern = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
	return SplCharacterPattern.test(alphabits.replace(/ /g, ""));
}

export function checkForOnlyNumber(input) {
	var onlyNumbers = /^\d+$/;
	return onlyNumbers.test(input);
}

export function checkMediaQuery() {
	const mediaQuery = window.matchMedia("(max-width: 700px)");
	if (mediaQuery) {
		return mediaQuery.matches;
	}
}

window.addEventListener("resize", checkMediaQuery);

export function validDate(d) {
	return d instanceof Date && !isNaN(d);
}

export const bookingConfirmed = {
	statusImg: "/images/bookingConfirmed.svg",
	statusLabel: constants.BOOKING_CONFIRMED,
	statusSummary: constants.SEND_GARAGE_ADD,
	banerColor: "var(--ion-color-lightgreen)",
};

export const bookingCancelled = {
	statusImg: "/images/bookingCancelled.svg",
	statusLabel: constants.BOOKING_CANCELLED,
	statusSummary: constants.BOOKING_CANCELLED_SUMMARY,
	banerColor: "var(--ion-color-darkpink)",
	queries: constants.ASK_QUERIES,
};

export function checkForPlural(count, word) {
	if (count > 1) {
		return word + "s";
	} else {
		return word;
	}
}

export function centroid(points) {
	var centroid = { x: 0, y: 0 };

	for (var i = 0; i < points.length; i++) {
		centroid.x += points[i].x;
		centroid.y += points[i].y;
	}

	centroid.x = centroid.x / points.length;
	centroid.y = centroid.y / points.length;

	return centroid;
}
